import React from 'react';
import Brick from './Brick';
import { FormsField, FormRenderer } from '../../components';
import { FormLayout } from '..';
import { Field } from 'redux-form';
import { Col, FormGroup, Label } from 'reactstrap';

/** Class representing a workflow brick to
 * show a form.
 */
class FormShowBrick extends Brick {
    /**
     * Get this brick options form
     *
     * @param {Object} props: an object with the following keys
     *                          - t
     *                          - workflow
     *                          - forms
     *                          - emails
     *                          - articles
     *                          - salepoints
     */
    getOptionsForm(props) {
        const { t, forms } = props;

        if (!forms)
            return null;

        return (
            <FormGroup row>
                <Label for="form_id" className="text-v-center" sm={4}>
                    { t('workflows.bricks.form.show.options.form_id') }
                </Label>
                <Col sm={8}>
                    <FormsField forms={forms} name={`bricks[${this.position}].options.form_id`} single />
                </Col>
            </FormGroup>
        );
    }

    /**
     * Run this brick
     */
    run(context, onDone) {
        if (!this.resources?.form)
            return null;

        const form = new FormLayout(this.resources.form);
        const submit = values => {
            context.forms = context.forms || {};
            context.forms[form.id] = values;
            onDone(context, (err, workflow) => {});
        }

        return (
            <div className="FormShowBrick">
                <FormRenderer
                    formLayout={ form }
                    onSubmit={ submit }
                    isLoading={ false }
                    defaultValues={ context }
                />
            </div>
        );
    }
}

export default FormShowBrick;
